import { FC, useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { Box } from '@mui/material';
import { HangerPhotoUploadGenerate } from './HangerPhotoUploadGenerate';
import { PageUrl } from '../../../../types/enums/pageUrl-enums';
import { useMannequinContext } from '../../context/MannequinContext';
import AIGenerationTypeQuery from '../../../../services/query/AIGenerationTypeQuery';
import './styles/HangerPhotographyFlow.scss';

interface LocationState {
    typeName?: string;
}

export const HangerPhotographyFlow: FC = () => {
    const history = useHistory();
    const location = useLocation<LocationState>();
    const { resetAIGeneration } = useMannequinContext();

    const queryParams = new URLSearchParams(location.search);
    const typeCode = queryParams.get('type');
    const typeNameFromState = location.state?.typeName || null;

    const [validatedTypeName, setValidatedTypeName] = useState<string | null>(typeNameFromState);
    const [isValidating, setIsValidating] = useState(!typeNameFromState && !!typeCode);

    // type parametresi yoksa type seçici sayfasına yönlendir
    // type parametresi varsa ama state'den name gelmediyse API'den doğrula
    useEffect(() => {
        if (!typeCode) {
            history.replace(PageUrl.studioRoutes.aiGeneration.url);
            return;
        }

        // State'den name geldiyse doğrulamaya gerek yok
        if (typeNameFromState) {
            setValidatedTypeName(typeNameFromState);
            setIsValidating(false);
            return;
        }

        // API'den type'ı doğrula
        setIsValidating(true);
        AIGenerationTypeQuery.GetAIGenerationTypeByCode(typeCode)
            .then((response: any) => {
                const data = response?.data?.data || response?.data;
                if (data && data.name) {
                    setValidatedTypeName(data.name);
                } else {
                    // Geçersiz type code - seçici sayfaya yönlendir
                    history.replace(PageUrl.studioRoutes.aiGeneration.url);
                }
            })
            .catch(() => {
                // API hatası veya bulunamadı - seçici sayfaya yönlendir
                history.replace(PageUrl.studioRoutes.aiGeneration.url);
            })
            .finally(() => {
                setIsValidating(false);
            });
    }, [typeCode, typeNameFromState, history]);

    const handleBack = () => {
        // Photography type selection'a dön
        resetAIGeneration();
        history.push(PageUrl.studioRoutes.aiGeneration.url);
    };

    const handleFinish = () => {};

    // type yoksa veya doğrulanıyorsa hiçbir şey render etme
    if (!typeCode || isValidating) {
        return null;
    }

    return (
        <Box className="hanger-photography-flow">
            <HangerPhotoUploadGenerate
                onFinish={handleFinish}
                onBack={handleBack}
                generationTypeName={validatedTypeName}
            />
        </Box>
    );
};
